import styled from 'styled-components';
import Card from 'components/Card';
import Plot from 'react-plotly.js';
import {
    GREY_800,
    GREY_500,
    DIVIDER,
    GREEN_100,
    GREEN_500,
    ORANGE_500,
} from '../../constants';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 120px);
`;

export const SumaryContainer = styled(Card)`
    display: flex;
    padding: 1.5rem 0;
    align-items: center;
    margin-bottom: 1rem;
    
    & > *:not(:first-child) {
        border-left: 1px solid ${DIVIDER};
    }
`;

export const IconContainer = styled.div`
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 0.375rem;
    background-color: ${GREEN_100};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${GREEN_500};
`;

export const UsageCard = styled(Card)`
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    margin-bottom: 1rem;
`;

export const UsageCardHeader = styled.header`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    height: 100%;
    margin-bottom: 1.5rem;
`;

export const UsageSummaryRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 0.25rem;
`;

export const TotalUsage = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: ${ORANGE_500};
    gap: 4px;
`;

export const UsageCardFooter = styled.footer`
    display: flex;
    flex-direction: column;
`;

export const CardTitle = styled.h3`
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: 0.0125rem;
    color: ${GREY_800};
`;

export const CardDescription = styled.p`
    font-size: 0.8125rem;
    font-weight: 300;
    line-height: 1rem;
    color: ${GREY_500};
`;

export const CardValue = styled.h1`
    font-size: 2rem;
    font-weight: 500;
    line-height: 3.25rem;
    color: ${GREY_800};
`;

export const HistoryCard = styled(Card)`
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const HistoryHeader = styled.header`
    display: flex;
    align-items: center;
    padding: 1.5rem;
`;

export const StyledPlot = styled(Plot)`
    width: 100%;
`;
